
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/internet/fiber-internet",
      function () {
        return require("private-next-pages/shop/internet/fiber-internet/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/internet/fiber-internet"])
      });
    }
  